import { StyleSheet } from 'react-native'

export const styles = StyleSheet.create({
  mainWrapper: { flex: 1, alignItems: 'center' },
  bottomTitle: {
    fontSize: 24,
    color: '#003353',
    fontWeight: '600',
    lineHeight: 30,
    marginTop: 40,
    marginBottom: 20,
  },
  bottomSubtitle: {
    fontSize: 18,
    fontWeight: '400',
    color: '#335C75',
    lineHeight: 26,
    textAlign: 'center',
  },
  button: {
    marginTop: 20,
    borderRadius: 4,
  },
})
